module.exports = __webpack_public_path__ + "static/media/driedhibiscusflower.d71ff3c0.png";